import defaultLoglevel from "loglevel";
import { InternalLoggerName } from "../Logger/LoggerName";
import { logEntryPlugin } from "../plugins/logEntryPlugin";
import { LoggerImpl } from "../Logger/LoggerImpl/LoggerImpl";
import { Logger, Loglevel } from "../Logger/Logger";
import { LoggerPlugin } from "./LoggerFactory";
import { LoggerConfigImpl } from "./LoggerConfigImpl";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { assertString } from "~/utils/assert";

class LoggerMap {
    private readonly map: Map<string, Logger>;

    constructor() {
        this.map = new Map();
    }

    get(name: string): Logger | undefined {
        return this.map.get(name);
    }

    set(name: string, logger: Logger): void {
        this.map.set(name, logger);
    }
}

export const getLogger =
    (ctx: ContextManager) =>
    (name: InternalLoggerName | string): Logger => {
        assertString(name, "name");
        const loggerMap = ctx.retrieveInstanceOf(ContextInstance.LoggerMap, LoggerMap);
        let logger = loggerMap.get(name);
        if (logger) {
            return logger;
        }
        const level = ctx.retrieveInstanceOf(ContextInstance.LoggerConfigImpl, LoggerConfigImpl).level;
        const plugins = [logEntryPlugin];
        const loglevel = plugins.reduce((instance: Loglevel, plugin: LoggerPlugin) => {
            return plugin(instance);
        }, defaultLoglevel.getLogger(name));

        logger = new LoggerImpl(loglevel);
        logger.setLevel(level);
        loggerMap.set(name, logger);
        return logger;
    };
